// extracted by mini-css-extract-plugin
export default {"program_options_container":"AdminProgramInformation_program_options_container__cfkHV","form_label_program_options":"AdminProgramInformation_form_label_program_options__PBK7N"};